// @ts-nocheck
// Every number here is read from the backend, not carried forward:
//   9   app/jurisdiction/adapters/register_default_adapters() registers nine
//       (GB, IE, EU, US-CA, DE, NL, AU, HK, CA-ON); NL is structural-only.
//   17  app/jurisdiction/registry.py — entries with in_launch_set=True.
//   1   the only free tool this site serves: /scan (the calculators and the
//       template library are India-only and 404 here — lib/edition/indiaOnlyRoutes.ts).
// Until 2026-09-18 this said 3 sources (EUR-Lex named — the EU adapter reads
// CELLAR, not EUR-Lex), 11 on the roadmap, and 3 free tools.
// 2026-10-08: the 9 statute sources and the 17-jurisdiction launch set were
// replaced — both describe the corpus pipeline, which gates what LexVio
// publishes and has published nothing a customer reads yet. Now:
//   14  app/services/privacy_packs/registry.py PACK_MODULES minus in_dpdp
//       (India-only); every pack content_status="drafted".
//   0   LexVio trains no model (services/ai_training.py: house-style
//       preferences, never a fine-tune).
const STATS = [
  { n: 3, label: "Modules under one login — Legal, Compliance, Agents" },
  { n: 14, label: "Data-protection laws in one privacy programme — every pack marked drafted until counsel checks it" },
  { n: 0, label: "Models trained on your documents — LexVio trains none, and identity documents never reach an AI vendor" },
  { n: 1, label: "Free tool live — the contract scanner, 3 scans a day, no account" },
];

export default function Stats() {
  return (
    <>
<div className="stats-sec">
  <div className="stats-header">
    <p className="stats-header-h">Honest scope, not vanity metrics.</p>
  </div>
  <div className="stats-grid" id="sgrid">
    {STATS.map((s, i) => (
      <div key={i} aria-label={`${s.n}. ${s.label}`} className="scell" role="group">
        <div aria-hidden="true" className="od-wrap">
          <div className="od-digits" data-target={s.n}>{s.n}</div>
        </div>
        <div className="scell-label">{s.label}</div>
      </div>
    ))}
  </div>
</div>


    </>
  );
}
